import { render, staticRenderFns } from "./SettingsApp.vue?vue&type=template&id=54d9a6d4&scoped=true&"
import script from "./SettingsApp.vue?vue&type=script&lang=js&"
export * from "./SettingsApp.vue?vue&type=script&lang=js&"
import style0 from "./SettingsApp.vue?vue&type=style&index=0&id=54d9a6d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d9a6d4",
  null
  
)

export default component.exports